<template>
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3332 2.00016C17.3332 1.0835 16.5832 0.333496 15.6665 0.333496H2.33317C1.4165 0.333496 0.666504 1.0835 0.666504 2.00016V12.0002C0.666504 12.9168 1.4165 13.6668 2.33317 13.6668H15.6665C16.5832 13.6668 17.3332 12.9168 17.3332 12.0002V2.00016ZM15.6665 2.0002L8.99987 6.16686L2.3332 2.0002H15.6665ZM2.3332 3.6668V12.0001H15.6665V3.6668L8.99987 7.83346L2.3332 3.6668Z"
      class="fill-current"
    />
  </svg>
</template>
